import { Group } from '@mantine/core';
import { inkDark, secondaryBase } from '../../../styles/design-tokens';
import { Icon } from '../../../ui-library/icon/icon';
import { Text } from '../../../ui-library/typography/typography';
import { TableHeader } from '../../data-management/components/data-sources-tab/data-source-table-header';

type CalculationGroupHeaderProps = {
  title: string;
  icon: string;
  isCollapsed: boolean;
  onToggle: () => void;
};

export function CalculationGroupHeader({ title, icon, isCollapsed, onToggle }: CalculationGroupHeaderProps) {
  return (
    <TableHeader
      onClick={onToggle}
      role="button"
      tabIndex={0}
      aria-expanded={!isCollapsed}
      aria-label={`${title} section, click to ${isCollapsed ? 'expand' : 'collapse'}`}
    >
      <Group style={{ flex: 1 }}>
        <Icon name={icon} size={20} color={secondaryBase} />
        <Text weight="bold" size="medium">
          {title}
        </Text>
      </Group>
      <Group>
        <Icon
          name={isCollapsed ? 'unfold_more' : 'unfold_less'}
          size={20}
          color={inkDark}
          style={{ cursor: 'pointer' }}
        />
      </Group>
    </TableHeader>
  );
}
